// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__180si","col":"styles_col__12Eo9"};